<div class="tac-container" role="group" aria-label="Azioni riga">

  <!-- ═══════════════════════════════════════════════════════════════════════
       DESKTOP (> 768px): pulsanti visibili + dropdown "ALTRO" per l'eccesso
       ═══════════════════════════════════════════════════════════════════════ -->
  <div class="tac-desktop" [class.tac-desktop--force-visible]="isMobileButtons()">

    @for (btn of mainActions(); track btn.id; let i = $index) {
      <button
        [class]="getButtonClass(i, btn)"
        [disabled]="btn.isDisabled | resolveLabel"
        [attr.aria-label]="btn.label | resolveLabel"
        [attr.aria-disabled]="btn.isDisabled | resolveLabel"
        (click)="executeAction(btn)"
        type="button"
      >
        <span class="btn__label label-small">{{ btn.label | resolveLabel }}</span>
        <span class="btn__icon">
          <app-svg-icon [src]="btn.svgIcon | resolveLabel"/>
          @if (btn.badge | resolveLabel; as badge) {
            <span class="btn__badge">{{ badge }}</span>
          }
        </span>
      </button>
    }

    @if (dropdownActions().length > 0) {
      <div class="tac-dropdown">
        <button
          class="btn btn--more"
          type="button"
          [attr.aria-haspopup]="'menu'"
          [attr.aria-expanded]="isDropdownOpen"
          [attr.aria-controls]="dropdownMenuId"
          (click)="toggleDropdown()"
          (keydown)="onTriggerKeydown($event)"
        >
          <span class="btn__label label-small">ALTRO</span>
          <span class="btn__icon btn__icon--chevron" [class.btn__icon--open]="isDropdownOpen" aria-hidden="true">
            <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="16"
                 height="16">
              <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" fill="none"/>
            </svg>
          </span>
        </button>

        @if (isDropdownOpen) {
          <ul
            [id]="dropdownMenuId"
            class="tac-dropdown__menu"
            role="menu"
            (keydown)="onDropdownKeydown($event)"
          >
            @for (item of dropdownActions(); track item.id) {
              <li role="none" class="tac-dropdown__item-wrapper">
                <button
                  #dropdownItem
                  role="menuitem"
                  type="button"
                  class="tac-dropdown__item"
                  [disabled]="item.isDisabled | resolveLabel"
                  [attr.aria-disabled]="item.isDisabled | resolveLabel"
                  [attr.aria-label]="item.label | resolveLabel"
                  (click)="executeAction(item, true)"
                >
                  <span class="tac-dropdown__item-icon">
                    <app-svg-icon [src]="item.svgIcon | resolveLabel"/>
                  </span>
                  <span class="tac-dropdown__item-label">{{ item.label | resolveLabel }}</span>
                  @if (item.badge | resolveLabel; as badge) {
                    <span class="tac-dropdown__item-badge">{{ badge }}</span>
                  }
                </button>
              </li>
            }
          </ul>
        }
      </div>
    }

  </div><!-- /tac-desktop -->


  <!-- ═══════════════════════════════════════════════════════════════════════
       MOBILE (≤ 768px): dropdown "Azioni" — nascosto se mobileMode='buttons'
       ═══════════════════════════════════════════════════════════════════════ -->
  @if (!isMobileButtons()) {
    <div class="tac-mobile">
      <div class="tac-dropdown">
        <button
          class="btn btn--more"
          type="button"
          [attr.aria-haspopup]="'menu'"
          [attr.aria-expanded]="isMobileDropdownOpen"
          [attr.aria-controls]="mobileDropdownMenuId"
          (click)="toggleMobileDropdown()"
          (keydown)="onMobileTriggerKeydown($event)"
        >
          <span class="btn__label label-small">Azioni</span>
          <span class="btn__icon btn__icon--chevron" [class.btn__icon--open]="isMobileDropdownOpen" aria-hidden="true">
            <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="16"
                 height="16">
              <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    fill="none"/>
            </svg>
          </span>
        </button>

        @if (isMobileDropdownOpen) {
          <ul
            [id]="mobileDropdownMenuId"
            class="tac-dropdown__menu tac-dropdown__menu--mobile"
            role="menu"
            (keydown)="onMobileDropdownKeydown($event)"
          >
            @for (item of allActions(); track item.id) {
              <li role="none" class="tac-dropdown__item-wrapper">
                <button
                  #mobileDropdownItem
                  role="menuitem"
                  type="button"
                  class="tac-dropdown__item"
                  [disabled]="item.isDisabled | resolveLabel"
                  [attr.aria-disabled]="item.isDisabled | resolveLabel"
                  [attr.aria-label]="item.label | resolveLabel"
                  (click)="executeAction(item, false, true)"
                >
                  <span class="tac-dropdown__item-icon">
                    <app-svg-icon [src]="item.svgIcon | resolveLabel"/>
                  </span>
                  <span class="tac-dropdown__item-label">{{ item.label | resolveLabel }}</span>
                  @if (item.badge | resolveLabel; as badge) {
                    <span class="tac-dropdown__item-badge">{{ badge }}</span>
                  }
                </button>
              </li>
            }
          </ul>
        }
      </div>
    </div><!-- /tac-mobile -->
  }

</div>

